import React from "react";
import Template from "../../../../templates/Crew/Departure/Create/Complete";
import Default from "../../../../layouts/DefaultCrew";

const Complete = (): React.ReactElement => {
  return (
    <Default title="" selectedTitle={"Departure"}>
      <Template />
    </Default>
  );
};

export default Complete;
